import utagLinkGeneric from './utagLinkGeneric';

function utagLinkWishList (eventCategory = 'Wish List') {

	return ({ eventAction, eventLabel = '' }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel
		});

	};

}

export default utagLinkWishList;
